<template>
  <div
    class="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black/60 p-5 backdrop-blur-sm"
    data-testid="loader"
  >
    <div class="flex max-w-[350px] flex-col items-center justify-center gap-y-9 lg:max-w-[600px]">
      <svg
        class="animate-spin lg:size-[153px]"
        width="112"
        height="111"
        viewBox="0 0 112 111"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41.0916 102.882C40.1256 105.952 41.8285 109.257 44.9829 109.896C50.5894 111.031 56.3495 111.295 62.0588 110.668C69.7034 109.829 77.0901 107.41 83.7503 103.564C90.4105 99.7189 96.1988 94.5314 100.748 88.3307C105.297 82.13 108.508 75.0515 110.177 67.5442C111.846 60.0369 111.937 52.2647 110.443 44.7206C108.949 37.1765 105.904 30.0251 101.5 23.7202C97.0968 17.4152 91.4308 12.0943 84.862 8.09496C79.9561 5.10807 74.6265 2.907 69.0671 1.5602C65.9391 0.802437 62.9966 3.07387 62.5709 6.26403C62.1451 9.45418 64.4026 12.3475 67.5082 13.1922C71.4726 14.2706 75.2753 15.9034 78.8009 18.05C83.9903 21.2095 88.4665 25.413 91.9454 30.3939C95.4243 35.3749 97.8301 41.0244 99.0101 46.9843C100.19 52.9441 100.119 59.0842 98.8001 65.0149C97.4816 70.9457 94.945 76.5377 91.351 81.4363C87.7571 86.3348 83.1843 90.433 77.9227 93.4708C72.6612 96.5086 66.8257 98.4197 60.7864 99.083C56.6834 99.5336 52.5471 99.4015 48.4992 98.6986C45.3282 98.148 42.0575 99.8124 41.0916 102.882Z"
          fill="white"
        />
        <path
          class="fill-main"
          d="M49.0869 104.689C48.639 107.876 45.6808 110.127 42.5582 109.348C35.6282 107.618 29.0788 104.562 23.28 100.329C15.9078 94.9483 9.97644 87.8324 6.01125 79.6117C2.04605 71.391 0.169453 62.3193 0.547674 53.2001C0.925895 44.0809 3.54726 35.1957 8.17958 27.3316C12.8119 19.4675 19.3122 12.8672 27.1046 8.11532C34.8971 3.36345 43.7412 0.606699 52.8535 0.0892623C61.9659 -0.428174 71.0652 1.30967 79.3455 5.14887C85.8586 8.16867 91.7068 12.4153 96.5795 17.6376C98.7751 19.9908 98.2406 23.6694 95.6702 25.6063C93.0999 27.5432 89.471 26.9967 87.2105 24.7057C83.5373 20.9828 79.2161 17.9357 74.443 15.7226C67.9015 12.6896 60.7131 11.3167 53.5143 11.7255C46.3155 12.1343 39.3287 14.3121 33.1727 18.0661C27.0166 21.8201 21.8814 27.0343 18.2219 33.247C14.5623 39.4596 12.4915 46.4789 12.1927 53.6831C11.8939 60.8872 13.3764 68.0539 16.5089 74.5483C19.6414 81.0426 24.3272 86.6642 30.1512 90.915C34.4009 94.0168 39.1609 96.3189 44.1979 97.7267C47.2975 98.593 49.5348 101.502 49.0869 104.689Z"
        />
      </svg>
      <p class="text-center text-sm text-white lg:text-2xl">{{ title }}</p>
    </div>
  </div>
</template>

<script setup>
const { title } = defineProps({
  title: {
    type: String,
    default:
      'Please Wait a few seconds, our system is calculating, don’t click any button now, or the back arrow'
  }
})
</script>
